import _slicedToArray from "/home/runner/work/design/design/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// Inspired from reach-ui: https://github.com/reach/reach-ui/blob/develop/packages/utils/src/use-force-update.ts
import React from 'react';
export var useForceUpdate = function useForceUpdate() {
  var _React$useState = React.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      rerender = _React$useState2[1];

  return React.useCallback(function () {
    return rerender({});
  }, []);
};